import axios from './../../../http.js';
export default {
    selectType() {
        return axios.post("/member/v1/member/application/list", {
            appId: "",
            appKey: "",
            request: {
                applicationName: "",
                pageNo: 1,
                pageSize: 10000,
            },
            version: "",
        }, {
            headers: {
                isLoading: false
            }
        })
    },
 
} 